import { ReactNode } from 'react'
import './Chip.css'
import clsx from 'clsx'

interface ChipProps {
    title: string
    subtitle: string
    image?: ReactNode
}

export default function Chip({ title, subtitle, image }: ChipProps) {
    return <div className={clsx('chip', !image && 'no-image')}>
        {image}
        <div className="text">
            <div className="title">{title}</div>
            <div className="subtitle">{subtitle}</div>
        </div>
    </div>
}
